/**
 * Google Analytics 4 helpers.
 * - gtag is loaded from index.html
 * - This module exposes typed wrappers for page_view and custom events
 * - Safe no-op when window.gtag is unavailable (SSR, ad-blockers, dev console without internet)
 */

const isEnabled = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

export const trackPageView = (pathname, title) => {
  if (!isEnabled()) return;
  window.gtag("event", "page_view", {
    page_path: pathname,
    page_location: window.location.href,
    page_title: title || document.title,
  });
};

export const trackEvent = (name, params = {}) => {
  if (!isEnabled()) return;
  window.gtag("event", name, params);
};

// Domain-specific events
export const trackRegisterClick = (source) =>
  trackEvent("register_click", { source });

export const trackWorkshopView = (workshopType) =>
  trackEvent("workshop_view", { workshop_type: workshopType });

export const trackSignupCompleted = ({ workshop_type, workshop_level, workshop_price }) =>
  trackEvent("signup_completed", {
    workshop_type,
    workshop_level,
    workshop_price,
    // Used by GA "conversions" reports
    value: parseFloat((workshop_price || "0").replace(/[^\d.]/g, "")) || 0,
    currency: "EUR",
  });

export const trackWhatsAppClick = (source) =>
  trackEvent("whatsapp_click", { source });

export const trackInstagramClick = (source) =>
  trackEvent("instagram_click", { source });
